import React, {useState} from "react";
import {useLocation, useNavigate} from "react-router-dom";
import {maintenanceVaild} from "../../../components/commonmethod/CommonMethod";
import Th_title from "../../../components/Th_title";
import {SelectComboBoxForCreate} from "../../../components/select/SelectComboBoxForCreate";
import {saveInspection} from "../../../api/maintenance/InspectionService";
import {useDispatch, useSelector} from "react-redux";
import {apiLoading} from "../../../redux/slice/apiSlice";
import {onCreateClickListener} from "../../../components/commonmethod/simmsDrawerMethod";
import SimmsInputSearch from "../../../components/input/SimmsInputSearch";
import SimmsDrawerSearch from "../../../components/drawer/simms/SimmsDrawerSearch";
import {CacheType, CodeSpecNum} from "../../../constant/CodeSpecNum";
import {inputOnChange} from "../../../components/commonmethod/simmsInputMethod";
import SimmsInput from "../../../components/input/SimmsInput";
import Selector from "../../../components/selector/Selector";
import SearchSelector from "../../../components/searchSelector/SearchSelector";
import UserSelectionField from "../../../components/selection/UserSelectionField";
import SimmsDatePicker from "../../../components/datepicker/SimmsDatePicker";
import {dateOnChange} from "../../../components/commonmethod/simmsDateMethod";
import dayjs from "dayjs";
import SimmsTextArea from "../../../components/input/SimmsTextArea";
import {SimmsRadio} from "../../../components/input/SimmsRadio";
import {useCacheRefresh} from "../../../hooks/useCacheRefresh";
import {
    ContentDetailThreeColLayout,
    DetailKvReadOnly,
    DetailKvTable,
    DetailFormPageShell,
    DetailListPage,
    DetailPanel,
    DetailSummaryButton,
} from "../../../components/detailLayout";
import "../../../components/detailLayout/detailListLayout.css";

export const inspectionRequestCode = [
    {id: "방문", name: "방문"},
    {id: "원격", name: "원격"},
    {id: "현장", name: "현장"}
];

export const useSla = [
    {value: true, text: "사용함"},
    {value: false, text: "사용안함"},
];

export const assetSingleOrBulkUseCode = [
    {value: "single", text: "자산개별 점검등록"},
    {value: "bulk", text: "자산일괄 점검등록"},
];

function InspectionCreate() {
    const dispatch = useDispatch();
    const user = useSelector(state => state.auth.user);
    const currentDate = new Date();
    const [inspection, setInspection] = useState({
        requestCode: 0, assetSingleOrBulkUse: "bulk", useSla: true, requester: user,
        periodicUse: false, inspector: user
    });
    const [assets, setAssets] = useState([]);
    const [handler, setHandler] = useState([]);
    const refreshCache = useCacheRefresh();
    const location = useLocation();
    const navigate = useNavigate();
    const requireds = ["title", "requester", "inspectCode", "inspectStartDate", "inspectEndDate", "useSla", "inspector"];

    const create = async () => {
        if (assets.length === 0) {
            alert("자산을 선택해주세요");
            return false;
        }

        if (!maintenanceVaild(handler, inspection, requireds)) return;

        dispatch(apiLoading(true));

        const updatedData = {
            ...inspection,
            inspectCode: {id: inspection.inspectCode.id},
            inspector: {id: inspection.inspector.id},
            requester: {id: inspection.requester.id}
        };

        await saveInspection(updatedData, assets, handler, []).then(response => {
            if (response.status === 200) {
                alert("등록되었습니다.");
                refreshCache(CacheType.INSPECTION);
                const newId = response.data?.id;
                if (newId) {
                    navigate(`/maintenance/inspection/${newId}`, {state: {id: newId}});
                } else {
                    navigate("/maintenance/inspection", {state: {test: location.state}});
                }
            }
        }).finally(() => dispatch(apiLoading(false)));
    };

    const requestInfoPanel = (
        <DetailPanel title="점검요청정보">
            <DetailKvTable>
                <tbody>
                <tr className="asset-detail-kv-row--auto">
                    <Th_title title="자산목록" colspan={3} className="fieldset-td relative align-top" required auth>
                        <UserSelectionField
                            layout="inline"
                            data={assets}
                            countUnit="개"
                            chipEntity="asset"
                            listModalTitle="자산목록"
                            onRemove={(v) => setAssets((prev) => prev.filter((asset) => asset.id !== v.id))}
                        >
                            <SearchSelector
                                auth
                                multiSelect
                                variant="compact"
                                entity="maintenance-assets"
                                uniqueKey="assets"
                                data={assets}
                                onChange={(v) => {
                                    if (v?.__multiFlat) setAssets(v.__multiFlat);
                                }}
                            >
                                <SimmsInputSearch type="TEXT"/>
                                <SimmsDrawerSearch showLabel title="자산그룹" entity="code" target="group" parentKey={CodeSpecNum.AssetGroupCode} uniqueKey="group" recursive/>
                                <SimmsDrawerSearch showLabel title="업무그룹" entity="code" target="task" parentKey={CodeSpecNum.TaskGroupCode} uniqueKey="task" recursive/>
                                <SimmsDrawerSearch showLabel title="자산위치" entity="code" target="location" parentKey={CodeSpecNum.AssetLocation} uniqueKey="location" recursive/>
                                <SimmsDrawerSearch showLabel title="SLA 그룹" entity="code" target="slaGroup" parentKey={CodeSpecNum.SlaGroupCode} uniqueKey="slaGroup" recursive/>
                                <SimmsDrawerSearch showLabel title="운영담당자" entity="userAccount" target="operator"/>
                                <SimmsDrawerSearch showLabel title="자산사용자" entity="userAccount" target="handler"/>
                            </SearchSelector>
                        </UserSelectionField>
                    </Th_title>
                </tr>
                <tr>
                    <Th_title title="구분" colspan={3} className="fieldset-td" auth>
                        <SimmsRadio
                            options={assetSingleOrBulkUseCode}
                            onChange={(v) => inputOnChange(setInspection, "assetSingleOrBulkUse", v, true)}
                            data={inspection.assetSingleOrBulkUse}
                        />
                    </Th_title>
                </tr>
                <tr>
                    <DetailKvReadOnly label="등록일시" value={currentDate.toISOString()} type="date"/>
                    <DetailKvReadOnly label="등록자" value={user.name}/>
                </tr>
                <tr>
                    <DetailKvReadOnly label="수정일시" value=""/>
                    <DetailKvReadOnly label="수정자" value=""/>
                </tr>
                <tr>
                    <Th_title title="점검 제목" colspan={3} className="fieldset-td" required auth>
                        <SimmsInput onChange={(v) => inputOnChange(setInspection, "title", v, true)} data={inspection.title}/>
                    </Th_title>
                </tr>
                <tr>
                    <Th_title title="요청자" colspan={3} className="fieldset-td" required auth>
                        <Selector
                            onChange={(v) => onCreateClickListener(setInspection, "requester", inspection.requester, v)}
                            data={inspection.requester}
                            entity="userAccount"
                            uniqueKey="requester"
                        >
                            <SimmsInputSearch type="TEXT" placeHolder="사용자명"/>
                            <SimmsDrawerSearch showLabel title="부서" entity="department" target="department" recursive/>
                            <SimmsDrawerSearch showLabel title="업체" entity="company" target="company"/>
                        </Selector>
                    </Th_title>
                </tr>
                <tr>
                    <Th_title title="점검코드" colspan={1} className="fieldset-td" required auth>
                        <Selector
                            onChange={(v) => onCreateClickListener(setInspection, "inspectCode", inspection.inspectCode, v)}
                            data={inspection.inspectCode}
                            entity="code"
                            parentKey={CodeSpecNum.InspectionRequestCode}
                            recursive
                        />
                    </Th_title>
                    <Th_title title="요청방식" colspan={1} className="fieldset-td" auth>
                        <SelectComboBoxForCreate
                            target="requestCode"
                            options={inspectionRequestCode}
                            data={{data: inspection, fnc: setInspection}}
                            defaultValue={inspection.requestCode}
                        />
                    </Th_title>
                </tr>
                <tr>
                    <Th_title title="점검기간" colspan={3} className="fieldset-td fieldset-td-input" required>
                        <div className="web-flex asset-detail-date-range">
                            <SimmsDatePicker
                                onChange={(v) => dateOnChange(setInspection, "inspectStartDate", v, true)}
                                data={inspection.inspectStartDate}
                                constraint={{lessThan: inspection.inspectEndDate && dayjs(inspection.inspectEndDate), required: true}}
                                auth
                            />
                            <span className="asset-detail-date-range-sep">~</span>
                            <SimmsDatePicker
                                onChange={(v) => dateOnChange(setInspection, "inspectEndDate", v, true)}
                                data={inspection.inspectEndDate}
                                constraint={{largerThan: inspection.inspectStartDate && dayjs(inspection.inspectStartDate), required: true}}
                                auth
                            />
                        </div>
                    </Th_title>
                </tr>
                <tr>
                    <Th_title title="SLA 사용여부" className="fieldset-td" colspan={3} required auth>
                        <SimmsRadio
                            options={useSla}
                            onChange={(v) => inputOnChange(setInspection, "useSla", v, true)}
                            data={inspection.useSla}
                        />
                    </Th_title>
                </tr>
                <tr>
                    <Th_title title="비고" colspan={3} className="fieldset-td" auth>
                        <SimmsTextArea onChange={(v) => inputOnChange(setInspection, "etc", v, false)} data={inspection.etc} style={{width: "100%", minHeight: "80px"}}/>
                    </Th_title>
                </tr>
                </tbody>
            </DetailKvTable>
        </DetailPanel>
    );

    const statusPanel = (
        <DetailPanel title="점검 요청 진행상태">
            <DetailKvTable>
                <tbody>
                <tr className="asset-detail-kv-row--auto">
                    <Th_title title="담당자" colspan={3} className="fieldset-td fieldset-td-input relative align-top" required auth>
                        <UserSelectionField
                            layout="inline"
                            data={handler}
                            onRemove={(v) => setHandler((prev) => prev.filter((h) => h.id !== v.id))}
                        >
                            <SearchSelector
                                auth
                                multiSelect
                                variant="compact"
                                entity="userAccount"
                                uniqueKey="handler"
                                data={handler}
                                onChange={(v) => {
                                    if (v?.__multiFlat) setHandler(v.__multiFlat);
                                }}
                            >
                                <SimmsInputSearch type="TEXT" placeHolder="사용자명"/>
                                <SimmsDrawerSearch showLabel title="부서" entity="department" target="department" recursive/>
                                <SimmsDrawerSearch showLabel title="업체" entity="company" target="company"/>
                            </SearchSelector>
                        </UserSelectionField>
                    </Th_title>
                </tr>
                <tr>
                    <Th_title title="검수자" colspan={3} className="fieldset-td" required auth>
                        <Selector
                            onChange={(v) => onCreateClickListener(setInspection, "inspector", inspection.inspector, v)}
                            data={inspection.inspector}
                            entity="userAccount"
                            uniqueKey="inspector"
                        >
                            <SimmsInputSearch type="TEXT" placeHolder="사용자명"/>
                            <SimmsDrawerSearch showLabel title="부서" entity="department" target="department" recursive/>
                            <SimmsDrawerSearch showLabel title="업체" entity="company" target="company"/>
                        </Selector>
                    </Th_title>
                </tr>
                </tbody>
            </DetailKvTable>
        </DetailPanel>
    );

    return (
        <DetailFormPageShell
            className="common-container container-height-full border-l-gray create-page detail-list-layout asset-detail-list-layout"
            title="점검 등록"
            meta="신규 점검 정보를 입력하세요"
            actions={
                <>
                    <DetailSummaryButton muted onClick={() => navigate("/maintenance/inspection")}>
                        취소
                    </DetailSummaryButton>
                    <DetailSummaryButton
                        onClick={() => {
                            if (window.confirm("등록 하시겠습니까?")) {
                                create();
                            }
                        }}
                    >
                        등록
                    </DetailSummaryButton>
                </>
            }
        >
            <DetailListPage isEditing className="flex min-h-0 flex-1 flex-col">
                <div className="container-height-body asset-detail-body detail-list-body flex min-h-0 flex-1 flex-col overflow-hidden">
                    <ContentDetailThreeColLayout primary={requestInfoPanel} secondary={statusPanel}/>
                </div>
            </DetailListPage>
        </DetailFormPageShell>
    );
}

export {InspectionCreate};
